import update from 'immutability-helper'

/*
   修改大会场基础信息  
 */

export function updateConference(node, action) {
  const { key, value, index } = action
  if (index) {
    // update
    if (key) {
      return update(node, {
        config: {
          tabs: {
            [index * 1]: {
              [key]: {
                $set: value,
              },
            },
          },
        },
      })
    } else {
      // delete
      return update(node, {
        config: {
          tabs: {
            $splice: [[index * 1, 1]],
          },
        },
      })
    }
  } else {
    return update(node, {
      config: {
        [key]: {
          $set: value,
        },
      },
    })
  }
}

export function addConferenceTabs(node) {
  if (node.config.tabs && node.config.tabs.length > 0) {
    return update(node, {
      config: {
        tabs: {
          $push: [
            {
              tabName: 'newTab',
            },
          ],
        },
      },
    })
  } else {
    return update(node, {
      config: {
        tabs: {
          $set: [{ tabName: 'newTab' }],
        },
      },
    })
  }
}
